// extracted by mini-css-extract-plugin
export default {"indicatorTutorial":"indicatorTutorial_indicatorTutorial__uu15a"};